import MapCardComponent from './MapCardComponent';
export * from './MapCardComponent';
export default MapCardComponent;
